export const JsonBlock = ({ title, data, testId }) => (
  <div className="flex min-w-0 flex-col rounded-2xl bg-navy p-4 text-white" data-testid={testId}>
    <div className="mb-2 text-xs font-semibold uppercase tracking-wider text-brand">{title}</div>
    <pre className="max-h-[480px] min-w-0 overflow-auto whitespace-pre text-[11px] leading-relaxed text-white/85">
      {data === undefined ? "—" : JSON.stringify(data, null, 2)}
    </pre>
  </div>
);
